import { RootState } from '../../rootReducer'

export const selectInvestorOpenVotesCloseToExpiration = (state: RootState) =>
  state.featuredVotes.investorOpenVotesCloseToExpiration

export const selectMostVotedOnInvestorOpenVote = (state: RootState) => state.featuredVotes.mostVotedOnInvestorOpenVote
